import { render, staticRenderFns } from "./rota.vue?vue&type=template&id=598f54c3&scoped=true"
import script from "./rota.vue?vue&type=script&lang=js"
export * from "./rota.vue?vue&type=script&lang=js"
import style0 from "./rota.vue?vue&type=style&index=0&id=598f54c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f54c3",
  null
  
)

export default component.exports